import {Tabs} from './tabs';
import {ReadyProvider} from '../../../application/providers/readyProvider';

ReadyProvider.executeOnReady(() => {
    let pageContent = document.querySelector('[data-content="all-shops"]'),
        tabs = new Tabs(pageContent),
        previousTab = null;

    pageContent.querySelector('[data-filter="search"]').addEventListener('input', (event) => {
        let searchValue = event.currentTarget.value;
        let currentPreviousTab = tabs.container.querySelector('.tabs-item-active').getAttribute('data-load');

        if (currentPreviousTab !== 'search') {
            previousTab = currentPreviousTab;
        }

        tabs.activateTabByName('search');

        if (searchValue) {
            clearTimeout(window.allShopsSerchTimeout);
            window.allShopsSerchTimeout = setTimeout(() => tabs.loadSearchTabContent(searchValue), 1000);
        } else {
            const event = new CustomEvent('click');
            pageContent.querySelector('[data-action="clear-search-filter"]').dispatchEvent(event);
        }
    });

    pageContent.querySelector('[data-action="clear-search-filter"]').addEventListener('click', (event) => {
        event.preventDefault();
        let filter = pageContent.querySelector('[data-filter="search"]');

        filter.value = '';
        tabs.clearSearchTabContent();
        tabs.activateTabByName(previousTab);
    });

    Array.from(pageContent.querySelectorAll('[data-tabs="button"]')).forEach((element) => element.addEventListener('click', () => {
        pageContent.querySelector('[data-filter="search"]').value = '';
    }));

    let categoryFilter = document.querySelector('[data-filter="category"]');

    if (categoryFilter) {
        categoryFilter.addEventListener('change', (event) => {
            tabs.loadCategoryTabContent(event.currentTarget.value);
        });
    }
});
